import {Exclude, Expose, Type} from 'class-transformer';
import {AbstractApiModel} from './abstract.api.model';
import {HyperlinkApiModel} from './hyperlink.api-model';

@Exclude()
export class SupportRequestAttachmentApiModel extends AbstractApiModel {
  @Expose() public name: string;
  @Expose() public size: string;
  @Expose() public mimeType: string;
  @Expose() public originalName: string;
  @Expose() public createdAt: Date;
  @Expose() @Type(() => HyperlinkApiModel) public hyperlinks: HyperlinkApiModel[];
}
